export default __webpack_public_path__ + "static/media/bG-Letters.805db66d.webp";